// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main{
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	padding-top: 12.4em;
	padding-bottom: 14.7em;
	position: relative;
	overflow: hidden;
}
.frame--main{
	padding-bottom: 1em;
}
.main__title{
	height: auto;
	width: 20.3125em;
	margin-bottom: 1.9em;
	pointer-events: none;
	-webkit-user-select: none;
	        user-select: none;
}
.main__text{ 
	line-height: 1.1875;
	padding: 0 3em;
	margin-bottom: 1.8em;
}
.main__btn{
	width: 5.8125em;
}
.main_emo svg{ 
	height: auto;
}
.main_emoWrapper{
	position: absolute;
	display: flex;
}
.main_emoWrapper:nth-child(1){
	left: -0.9em;
    bottom: 4.7em;
}
.main_emoWrapper:nth-child(1) svg{
	transform: rotate(26.21deg);
	width: 8.7em;
}
.main_emoWrapper:nth-child(2){
    right: -1.3em;
    top: 1.9em;
}
.main_emoWrapper:nth-child(2) svg{
	transform: rotate(-17.3deg);
	width: 7.05em;
}
.main_emoWrapper:nth-child(3){
	bottom: 8.8em;
    right: -1.4em;
} 
.main_emoWrapper:nth-child(3) svg{
	width: 5.4em;
}
.main_emoWrapper:nth-child(4){
	left: -0.7em;
    top: 4.9em;
}
.main_emoWrapper:nth-child(4) svg{
	transform: rotate(7deg);
	width: 5.41em;
}

.main_emo{
    display: none;
}
@media(min-width: 100vh){
	.main_emo{
	    display: block;
	}
	.frame--main{
		padding-bottom: 0;
	}
	.main{
		padding-top: 18.5em;
		overflow: inherit;
		padding-bottom: 0;
	}
	.main__title{
		width: 44.4375em;
		margin-left: 1.4em;
		margin-bottom: 2.25em;
	}
	.main__text{
		font-size: 1.625em;
		line-height: 1.1923;
		max-width: 20em;
		padding: 0;
		margin-bottom: 1.75em;
	}
	.main__btn{
		width: 10.375em; 
	} 
	.main__btn span{
		font-size: 1.25em;
	}
	.main_emoWrapper:nth-child(1){
		left: 50%;
		margin-left: 28.3em;
    	top: 22.2em;
	    bottom: inherit;
	    animation: mainImage 12s ease-in-out 0s normal infinite;  
	}
	.main_emoWrapper:nth-child(1) svg{
		transform: rotate(26.21deg);
		width: 17.875em;
	}
	.main_emoWrapper:nth-child(2){
	    right: 50%;
	    margin-right: 24.6em;
    	top: 1.9em;
	    animation: mainImage 12s ease-in-out 2s normal infinite;  
	}
	.main_emoWrapper:nth-child(2) svg{
		transform: rotate(-17.3deg);
		width: 20em;
	}
	.main_emoWrapper:nth-child(3){
		bottom: inherit;
		top: 35em;
	    right: 50%;
	    margin-right: 32.7em;
	    animation: mainImage 12s ease-in-out 4s normal infinite;  
	}
	.main_emoWrapper:nth-child(3) svg{
		width: 14.8em; 
	}
	.main_emoWrapper:nth-child(4){
		left: 50%;
		margin-left: 35em;
    	top: 47.7em;
	    animation: mainImage 12s ease-in-out 6s normal infinite;  
	}
	.main_emoWrapper:nth-child(4) svg{
		transform: rotate(7deg);
		width: 11.1em;
	}
}



@keyframes mainImage {
  0% {
    transform: translate(0,0);
  } 
  12.5% {
    transform: translate(1.5em, -2em);
  }
  25% {
    transform: translate(-2em, -1.5em);
  } 
  50% {
    transform: translate(-1.5em, 2em);
  } 
  65% {
    transform: translate(2em, 1.5em);
  }
  80% {
    transform: translate(1.5em, -2em);
  }
  100% {
    transform: translate(0,0);
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/Main/main.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;CACnB,sBAAsB;CACtB,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,gBAAgB;CAChB,oBAAoB;CACpB,oBAAoB;CACpB,yBAAiB;SAAjB,iBAAiB;AAClB;AACA;CACC,mBAAmB;CACnB,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,eAAe;AAChB;AACA;CACC,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,aAAa;AACd;AACA;CACC,YAAY;IACT,aAAa;AACjB;AACA;CACC,2BAA2B;CAC3B,YAAY;AACb;AACA;IACI,aAAa;IACb,UAAU;AACd;AACA;CACC,2BAA2B;CAC3B,aAAa;AACd;AACA;CACC,aAAa;IACV,aAAa;AACjB;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;IACT,UAAU;AACd;AACA;CACC,uBAAuB;CACvB,aAAa;AACd;;AAEA;IACI,aAAa;AACjB;AACA;CACC;KACI,cAAc;CAClB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;CAClB;CACA;EACC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;CACtB;CACA;EACC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,qBAAqB;CACtB;CACA;EACC,eAAe;CAChB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,SAAS;EACT,mBAAmB;KAChB,WAAW;KACX,eAAe;KACf,uDAAuD;CAC3D;CACA;EACC,2BAA2B;EAC3B,eAAe;CAChB;CACA;KACI,UAAU;KACV,oBAAoB;KACpB,UAAU;KACV,uDAAuD;CAC3D;CACA;EACC,2BAA2B;EAC3B,WAAW;CACZ;CACA;EACC,eAAe;EACf,SAAS;KACN,UAAU;KACV,oBAAoB;KACpB,uDAAuD;CAC3D;CACA;EACC,aAAa;CACd;CACA;EACC,SAAS;EACT,iBAAiB;KACd,WAAW;KACX,uDAAuD;CAC3D;CACA;EACC,uBAAuB;EACvB,aAAa;CACd;AACD;;;;AAIA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".main{\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\ttext-align: center;\n\tpadding-top: 12.4em;\n\tpadding-bottom: 14.7em;\n\tposition: relative;\n\toverflow: hidden;\n}\n.frame--main{\n\tpadding-bottom: 1em;\n}\n.main__title{\n\theight: auto;\n\twidth: 20.3125em;\n\tmargin-bottom: 1.9em;\n\tpointer-events: none;\n\tuser-select: none;\n}\n.main__text{ \n\tline-height: 1.1875;\n\tpadding: 0 3em;\n\tmargin-bottom: 1.8em;\n}\n.main__btn{\n\twidth: 5.8125em;\n}\n.main_emo svg{ \n\theight: auto;\n}\n.main_emoWrapper{\n\tposition: absolute;\n\tdisplay: flex;\n}\n.main_emoWrapper:nth-child(1){\n\tleft: -0.9em;\n    bottom: 4.7em;\n}\n.main_emoWrapper:nth-child(1) svg{\n\ttransform: rotate(26.21deg);\n\twidth: 8.7em;\n}\n.main_emoWrapper:nth-child(2){\n    right: -1.3em;\n    top: 1.9em;\n}\n.main_emoWrapper:nth-child(2) svg{\n\ttransform: rotate(-17.3deg);\n\twidth: 7.05em;\n}\n.main_emoWrapper:nth-child(3){\n\tbottom: 8.8em;\n    right: -1.4em;\n} \n.main_emoWrapper:nth-child(3) svg{\n\twidth: 5.4em;\n}\n.main_emoWrapper:nth-child(4){\n\tleft: -0.7em;\n    top: 4.9em;\n}\n.main_emoWrapper:nth-child(4) svg{\n\ttransform: rotate(7deg);\n\twidth: 5.41em;\n}\n\n.main_emo{\n    display: none;\n}\n@media(min-width: 100vh){\n\t.main_emo{\n\t    display: block;\n\t}\n\t.frame--main{\n\t\tpadding-bottom: 0;\n\t}\n\t.main{\n\t\tpadding-top: 18.5em;\n\t\toverflow: inherit;\n\t\tpadding-bottom: 0;\n\t}\n\t.main__title{\n\t\twidth: 44.4375em;\n\t\tmargin-left: 1.4em;\n\t\tmargin-bottom: 2.25em;\n\t}\n\t.main__text{\n\t\tfont-size: 1.625em;\n\t\tline-height: 1.1923;\n\t\tmax-width: 20em;\n\t\tpadding: 0;\n\t\tmargin-bottom: 1.75em;\n\t}\n\t.main__btn{\n\t\twidth: 10.375em; \n\t} \n\t.main__btn span{\n\t\tfont-size: 1.25em;\n\t}\n\t.main_emoWrapper:nth-child(1){\n\t\tleft: 50%;\n\t\tmargin-left: 28.3em;\n    \ttop: 22.2em;\n\t    bottom: inherit;\n\t    animation: mainImage 12s ease-in-out 0s normal infinite;  \n\t}\n\t.main_emoWrapper:nth-child(1) svg{\n\t\ttransform: rotate(26.21deg);\n\t\twidth: 17.875em;\n\t}\n\t.main_emoWrapper:nth-child(2){\n\t    right: 50%;\n\t    margin-right: 24.6em;\n    \ttop: 1.9em;\n\t    animation: mainImage 12s ease-in-out 2s normal infinite;  \n\t}\n\t.main_emoWrapper:nth-child(2) svg{\n\t\ttransform: rotate(-17.3deg);\n\t\twidth: 20em;\n\t}\n\t.main_emoWrapper:nth-child(3){\n\t\tbottom: inherit;\n\t\ttop: 35em;\n\t    right: 50%;\n\t    margin-right: 32.7em;\n\t    animation: mainImage 12s ease-in-out 4s normal infinite;  \n\t}\n\t.main_emoWrapper:nth-child(3) svg{\n\t\twidth: 14.8em; \n\t}\n\t.main_emoWrapper:nth-child(4){\n\t\tleft: 50%;\n\t\tmargin-left: 35em;\n    \ttop: 47.7em;\n\t    animation: mainImage 12s ease-in-out 6s normal infinite;  \n\t}\n\t.main_emoWrapper:nth-child(4) svg{\n\t\ttransform: rotate(7deg);\n\t\twidth: 11.1em;\n\t}\n}\n\n\n\n@keyframes mainImage {\n  0% {\n    transform: translate(0,0);\n  } \n  12.5% {\n    transform: translate(1.5em, -2em);\n  }\n  25% {\n    transform: translate(-2em, -1.5em);\n  } \n  50% {\n    transform: translate(-1.5em, 2em);\n  } \n  65% {\n    transform: translate(2em, 1.5em);\n  }\n  80% {\n    transform: translate(1.5em, -2em);\n  }\n  100% {\n    transform: translate(0,0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
